import { BaseApiResponse } from "../../models/BaseApiResponse";
import { BatchNotificationResponse, PushNotificationPayload, PushNotificationRedirectPayload } from "../../models/notifications";
import { api } from "./api";
import { transformBasicResponse } from "./backend-transformers";

type SendPushResponse = BaseApiResponse<BatchNotificationResponse | PushNotificationPayload>;

export const notificationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    sendPushNotification: build.mutation<SendPushResponse, PushNotificationPayload | PushNotificationRedirectPayload>({
      query: (payload) => ({
        url: "bo/notifications/push/send/deeplink",
        method: "POST",
        body: payload,
      }),
      transformResponse: transformBasicResponse,
    }),
  }),
});

export const {
  useSendPushNotificationMutation,

} = notificationsApi;


